import React, { memo } from "react";
import { NavLink } from "react-router-dom";

import Icon from "../assets/icons/Icon";
import { Image } from "../Components";

const Sidebar = () => {
  return (
    <>
      <aside className="startbar d-print-none">
        <div className="brand">
          <NavLink to="/" className="logo">
            <span className="">
              <Image
                src="/assets/images/light-logo2.png"
                className="logo-lg logo-light"
              />
            </span>
          </NavLink>
          <span className="arrow_sidebar_icon">
            <Icon name="FaArrowLeft" />
          </span>
        </div>
        <div className="startbar-menu">
          <div
            className="startbar-collapse"
            id="startbarCollapse"
            data-simplebar
          >
            <div className="d-flex align-items-start flex-column w-100">
              <ul className="navbar-nav mb-auto w-100">
                <li className="menu-label mt-2">
                  <span>Master</span>
                </li>

                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/",
                      state: { heading: "Dashboard" },
                    }}
                  >
                    <Icon
                      name="MdDashboard"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Dashboard</span>
                  </NavLink>
                </li>

                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/import",
                      state: { heading: "Import" },
                    }}
                  >
                    <Icon
                      name="MdDashboard"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Import</span>
                  </NavLink>
                </li>
                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/instrument",
                      state: { heading: "instrument" },
                    }}
                  >
                    <Icon
                      name="FaList"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Instrument List</span>
                  </NavLink>
                </li>
                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/exchange",
                      state: { heading: "instrument" },
                    }}
                  >
                    <Icon
                      name="FaExchangeAlt"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Exchange List</span>
                  </NavLink>
                </li>
                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/badla/instrument",
                      state: { heading: "instrument" },
                    }}
                  >
                    <Icon
                      name="BiMath"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Badla Instrument</span>
                  </NavLink>
                </li>
                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/badla/setting",
                      state: { heading: "instrument" },
                    }}
                  >
                    <Icon
                      name="IoSettings"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Badla Setting</span>
                  </NavLink>
                </li>
                <li className={`nav-item`}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={{
                      pathname: "/dollar/rate",
                      state: { heading: "instrument" },
                    }}
                  >
                    <Icon
                      name="FaDollarSign"
                      className="iconoir-report-columns menu-icon"
                    />
                    <span>Dollar Rate</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>
      <div className="startbar-overlay d-print-none"></div>
    </>
  );
};

export default memo(Sidebar);
